<template>
  <div class="searchWrapper_parent">
    <el-popover
      v-model="show"
      ref="popover"
      placement="bottom"
      width="274"
      trigger="click"
      :append-to-body="false"
      :visible-arrow="false"
      :placement="`bottom-end`"
    >
      <div v-outside="outsideEvents" class="searchWrapper">
        <div style="display: flex">
          <el-input
            ref="searchInput"
            v-model="keywords"
            :placeholder="$t('header.searchMenu')"
            size="mini"
            @input="inputEvents"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <i
              slot="suffix"
              class="el-input__icon el-icon-error"
              style="font-size: 14px;cursor: pointer;"
              v-show="keywords != ''"
              @click="clearEvents"
            ></i>
          </el-input>
        </div>

        <div
          v-show="
            keywords == '' && showMenu.length == 0 && showConfigMenu.length == 0
          "
        >
          <div style="font-size: 12px; color:#969799;margin: 8px 0 10px">
            {{ $t('header.recentSearch') }}
          </div>
          <span
            class="serachHistoryItem"
            v-for="(item, index) in searchHistory"
            :key="`serachHistory${index}`"
            @click="searchHistoryEvents(item)"
            >{{ item }}</span
          >
        </div>
        <div
          class="item"
          style="color:#969799;padding:0"
          v-show="keywords != ''"
        >
          {{ $t('header.searchResultCount', { count }) }}
        </div>
        <div
          class="wrapper"
          v-show="showMenu.length == 0 && showConfigMenu.length == 0"
        >
          <div class="img"></div>
          <span class="tips">{{ $t('header.noData') }}</span>
        </div>
        <div class="resultContainer" ref="resultContainer">
          <div
            v-for="(item, index) in showMenu"
            :key="item.menuKey"
            :class="`menuItem ${select == index ? 'select' : ''}`"
            @click="goUrl(item)"
            @mousemove="mouseEnterEvents(index)"
            :title="item.fullName.join('/')"
          >
            {{ item.fullName.slice(0, -1).join("/") }}
            {{ item.fullName.length == 1 ? "" : "/"
            }}<span
              v-html="
                item.fullName
                  .slice(-1)[0]
                  .replace(
                    keywords,
                    `<span style='color:#0090FF'>${keywords}</span>`
                  )
              "
            ></span>
          </div>
          <div
            v-for="(item, index) in showConfigMenu"
            :key="item.menuKey"
            :class="
              `configMenuItem ${
                select == showMenu.length + index ? 'select' : ''
              }`
            "
            @mousemove="mouseEnterEvents(showMenu.length + index)"
          >
            <div class="item" :title="item.fullName.join('/')">
              {{ item.fullName.join("/") }}
            </div>
            <div
              class="menuItem"
              v-for="i in item.configNames"
              :key="i"
              style="padding-left:20px"
              @click="goUrl(item)"
              v-html="
                i.replace(
                  keywords,
                  `<span style='color:#0090FF'>${keywords}</span>`
                )
              "
            ></div>
          </div>
        </div>
      </div>
    </el-popover>
    <el-button :class="['btn',isMiniScreen?'mini':'']" v-popover:popover>
      <i class="iconfont icon-sousuo-line"></i>
      <span v-show="!isMiniScreen">{{ $t('header.searchShortcut', { shortcut: isMac() ? '⌘K' : 'Ctrl+K' }) }}</span>
    </el-button>
  </div>
</template>
<script>
import { postMenuItemSearch } from "@/api";
import { mapActions, mapState } from "vuex";
import { hmt_statistic } from "@/utils/index";

export default {
  props: {
    isMiniScreen: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      show: false,
      keywords: "",
      count: 0,
      showMenu: [],
      showConfigMenu: [],
      loading: false,
      searchHistoryKey: 'searchHistory',
      searchHistory: [],
      select: 0
    };
  },
  watch: {
    show(val, oldVal) {
      if (val && !oldVal) {
        hmt_statistic(location.href, '导航栏-搜索')
        this.$nextTick(_ => {
          this.$refs.searchInput && this.$refs.searchInput.focus();
        });
      }
      //弹窗关闭时 保存历史搜索记录
      if (!val && oldVal) {
        this.saveHistoryKeywords();
      }
    },
    userInfo:{
      immediate:true,
      handler(val){
      if(Object.keys(val).length>0){
        this.initSearchInfo()
      }
    }
    }
  },
  computed: {
    ...mapState(["menuList", "userInfo"]),
    allMenu() {
      return this.expandArray(this.menuList);
    }
  },
  mounted() {
    document.addEventListener("keydown", this.ctrlKEvents);
  },
  beforeDestory() {
    document.removeEventListener("keydown", this.ctrlKEvents);
  },
  methods: {
    ...mapActions(["addTab"]),
    initSearchInfo(){
      const {vccId='',userNum=''} = this.userInfo || {}
      let key = `SearchHistory_${vccId}_${userNum}`
      this.searchHistoryKey = key

      this.searchHistory = JSON.parse(localStorage.getItem(key)) || []
    },
    mouseEnterEvents(index) {
      this.select = index;
    },
    // 点击弹出层外面，关闭弹窗
    outsideEvents(e) {
      this.show = false;
    },
    // 判断操作系统
    isMac() {
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (isMac) {
        return true;
      }
      return false;
    },
    // 按键事件
    ctrlKEvents(e) {
      let isMac = this.isMac();
      let flag = isMac ? e.metaKey : e.ctrlKey;
      if (flag && e.keyCode === 75) {
        e.preventDefault();
        this.show = true;
        setTimeout(_ => {
          this.$refs.searchInput && this.$refs.searchInput.focus();
        }, 500);
      }
      if (this.show) {
        if (e.keyCode == 38 && this.select > 0) {
          e.preventDefault();
          this.select--;
          this.$nextTick(_ => {
            document.querySelector(".select").scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center"
            });
          });
        } else if (
          e.keyCode == 40 &&
          this.select < this.showMenu.length + this.showConfigMenu.length - 1
        ) {
          e.preventDefault();
          this.select++;
          this.$nextTick(_ => {
            document.querySelector(".select").scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center"
            });
          });
        } else if (e.keyCode == 13) {
          e.preventDefault();
          if (this.select >= 0 && this.select < this.showMenu.length) {
            let item = this.showMenu[this.select];
            if (item) this.goUrl(item);
          } else if (this.select >= this.showMenu.length) {
            let item = this.showConfigMenu[this.select - this.showMenu.length];
            if (item) this.goUrl(item);
          }
        }
      }
    },
    // input框搜索栏清空事件
    clearEvents() {
      //清空关键字之前 保存历史记录
      this.saveHistoryKeywords();
      this.keywords = "";
      this.searchEvents();
    },
    // 点击历史记录事件
    searchHistoryEvents(keywords) {
      this.keywords = keywords;
      this.searchEvents();
    },
    //点击菜单列表事件
    goUrl(item) {
      this.addTab(item);
      this.$nextTick(_ => {
        this._Bus.$emit("clickTab", item);
        this.show = false;
      });
    },
    //根据条件查找到目标元素的所有父级
    findTargetFromDeepArray(target, array, parent) {
      parent = parent || [];
      let result = [];
      array.forEach(i => {
        if (i.menuKey == target) {
          result.push([...parent, i].filter(Boolean));
        }
        if (Array.isArray(i.children)) {
          result.push(
            ...this.findTargetFromDeepArray(target, i.children, [...parent, i])
          );
        }
      });
      return result;
    },
    //将深层数组转换成一维数组
    expandArray(array, parentMenuKey, parentMenuName) {
      if (!Array.isArray(array)) {
        return [];
      }
      parentMenuKey = parentMenuKey || [];
      parentMenuName = parentMenuName || [];
      let result = [];
      array.forEach(i => {
        if (Array.isArray(i.children)) {
          result.push(
            ...this.expandArray(
              i.children,
              [...parentMenuKey, i.menuKey],
              [...parentMenuName, i.name]
            )
          );
        } else {
          let fullPath = [...parentMenuKey, i.menuKey];
          let fullName = [...parentMenuName, i.name];
          let subPath = [];
          let thdPath = [];
          if (fullPath.length >= 5) {
            subPath = fullPath.slice(1, 3);
            thdPath = fullPath.slice(3);
          } else {
            subPath = fullPath.slice(1);
          }
          let item = {
            fullPath,
            fullName,
            icon: i.icon,
            key: i.menuKey,
            mainMenuKey: fullPath[0],
            subActive: {
              path: subPath,
              key: subPath[subPath.length - 1]
            },
            thdActive: {
              path: thdPath,
              key: thdPath[thdPath.length - 1]
            },
            name: i.name,
            refresh: true,
            url: i.url,
            type: i.type
          };
          result.push(item);
        }
      });
      return result;
    },
    inputEvents(e) {
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.searchEvents();
      }, 500);
    },
    // 保存历史搜索记录
    saveHistoryKeywords() {
      let keyword = this.keywords.trim();
      if (!keyword) return;
      // 获取历史搜索记录
      let searchHistory = [...this.searchHistory];
      //剔除重复数据
      searchHistory = searchHistory.filter(i => i != keyword);
      //将重复数据添加到数组最后一条
      searchHistory.unshift(keyword);
      //截取数组最新的6条
      searchHistory = searchHistory.slice(0, 6);
      this.searchHistory = searchHistory;
      localStorage.setItem(this.searchHistoryKey, JSON.stringify(searchHistory));
    },
    searchEvents() {
      this.count = 0;
      // 获取搜索关键字
      let keyword = this.keywords.trim();
      // 如果关键字为空，清空菜单列表（showMenu）和配置列表（showConfigMenu）
      if (keyword == "") {
        this.showMenu = [];
        this.showConfigMenu = [];
        return;
      }
      postMenuItemSearch({ keyword }).then(res => {
        let { code, data } = res;
        if (code == 0) {
          // 获取showConfigMenu的逻辑与获取showMenu的逻辑差不太多都是根据接口返回的menu_key找到对应的菜单
          let target = data
            .map(item => {
              let select = this.allMenu.filter(i => i.key == item.menu_key)[0];
              if (select) {
                return {
                  ...select,
                  configNames: [item.menu_item]
                };
              }
            })
            .filter(Boolean);
          let showConfigMenu = [];
          target.forEach(item => {
            let filter = showConfigMenu.filter(i => i.key == item.key)[0];
            if (filter) {
              filter.configNames = [...filter.configNames, ...item.configNames];
            } else {
              showConfigMenu.push({
                ...item,
                configNames: item.configNames
              });
            }
          });

          // 根据name字与keyword匹配找出筛选项
          let showMenu = this.allMenu.filter(i => i.name.indexOf(keyword) > -1);
          // 过滤showMenu，如果存在showConfigMenu中的页面则，剔除出去，以showConfigMenu为主
          showMenu = showMenu.filter(item => {
            let flag = true;
            for (let i = 0; i < showConfigMenu.length; i++) {
              if (showConfigMenu[i].key == item.key) {
                flag = false;
                return;
              }
            }
            return flag;
          });
          this.showConfigMenu = showConfigMenu;
          this.showMenu = showMenu;
          this.count = showMenu.length + target.length;
          this.select = 0;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.searchWrapper_parent {
  display: inline-block;

  /deep/ div[role="tooltip"] {
    margin-top: 9px;
  }
}
.select {
  background: #f2f4f5;
}
.searchWrapper {
  height: 334px;
  overflow: hidden;
  &:focus-visible {
    border: none;
    outline: none;
  }
}
.btn {
  cursor: pointer;
  background: #42454d;
  color: #fff;
  border: none;
  height: 32px;
  padding: 0 8px;
  font-size: 14px;
  text-align: center;

  &.mini{
    background-color: transparent;
    position: relative;

    &:hover{
      background-color: rgba(247, 247, 247, 0.15)
    }

    &::after{
      content: '';
      display: block;
      position: absolute;
      right: 0;
      top: 10px;
      width: 1px;
      height: 16px;
      background-color: rgba(220, 222, 224, 0.2);
    }
  }


}
.menuItem {
  cursor: pointer;
  line-height: 28px;
  font-size: 12px;
  padding-left: 8px;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    background: #f2f4f5;
  }
}
.configMenuItem {
  cursor: pointer;
  &:hover {
    background: #f2f4f5;
  }
}

.item {
  padding-left: 8px;
  line-height: 28px;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.serachHistoryItem {
  // margin-right: 16px;
  display: inline-block;
  padding: 3px 8px;
  margin: 0 10px 10px 0;
  border-radius: 4px;
  background: #f2f3f5;
  border: 1px solid #dcdee0;
  cursor: pointer;
  font-size: 12px;
  border-right: 1px solid #e8e8e8;
  color: #323233;
  &:last-of-type {
    border-right: none;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 300px;
  flex-direction: column;
  margin: 80px auto;

  .img {
    width: 62px;
    height: 42px;
    background: url(../../../../assets/images/img_jichu.png) no-repeat center;
  }

  .tips {
    font-size: 12px;
    color: #b4b5bb;
    margin-top: 10px;
  }
}
.resultContainer {
  height: calc(~"100% - 56px");
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #cccccc;
  }
  &::-webkit-scrollbar-track {
    border-radius: 4px;
    background: #ededed;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/header/SearchWrapper/index.vue